import { UserRound } from "lucide-react";
import Reveal from "./Reveal";
import { MEDICAL_DIRECTOR, PRACTITIONER } from "@/config/clinicConfig";

function PortraitFrame({ name, photo, alt }) {
  const initials = name.replace("Dr. ", "").split(" ").map((w) => w[0]).join("");
  if (photo) {
    return (
      <div className="mx-auto aspect-[4/5] w-1/2 overflow-hidden rounded-2xl bg-sand">
        <img src={photo} alt={alt} className="h-full w-full object-cover object-top" />
      </div>
    );
  }
  return (
    <div className="relative mx-auto flex aspect-[4/5] w-1/2 flex-col items-center justify-center gap-3 rounded-2xl bg-sand">
      <span className="font-display text-5xl font-medium text-clay/60">{initials}</span>
      <p className="flex items-center gap-1.5 rounded-full border border-dashed border-clay/40 px-3 py-1 text-[11px] font-medium text-cocoa">
        <UserRound size={12} />
        Photo coming soon
      </p>
    </div>
  );
}

export default function Team() {
  return (
    <section id="team" data-testid="team-section" className="pt-10 pb-24 lg:pt-14 lg:pb-32">
      <div className="mx-auto max-w-5xl px-5 lg:px-8">
        <Reveal className="text-center">
          <h2 className="font-display text-3xl font-medium tracking-tight text-espresso sm:text-4xl lg:text-[2.75rem]">
            Meet your experts
          </h2>
        </Reveal>
        <div className="mt-12 grid gap-6 sm:grid-cols-2 lg:gap-10">
          <Reveal>
            <div
              data-testid="team-card-practitioner"
              className="h-full rounded-3xl border border-espresso/10 bg-card p-6 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-30px_rgba(44,34,30,0.4)]"
            >
              <PortraitFrame
                name={PRACTITIONER.name}
                photo={PRACTITIONER.photo}
                alt="Sherry Corvino, laser eyeliner and cosmetic tattoo removal specialist"
              />
              <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-espresso">
                {PRACTITIONER.name}, {PRACTITIONER.credentials}
              </h3>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-clay">
                {PRACTITIONER.title}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-cocoa">
                Founder of Beauté Solutions and creator of the Pinpoint laser removal process.
              </p>
            </div>
          </Reveal>

          <Reveal delay={0.12}>
            <div
              data-testid="team-card-director"
              className="h-full rounded-3xl border border-espresso/10 bg-card p-6 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_28px_60px_-30px_rgba(44,34,30,0.4)]"
            >
              <PortraitFrame
                name={MEDICAL_DIRECTOR.name}
                photo={MEDICAL_DIRECTOR.photo}
                alt="Dr. Pam Henderson, Medical Director"
              />
              <h3 className="mt-6 font-display text-2xl font-semibold tracking-tight text-espresso">
                {MEDICAL_DIRECTOR.name}, {MEDICAL_DIRECTOR.credentials}
              </h3>
              <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.2em] text-clay">
                {MEDICAL_DIRECTOR.title}
              </p>
              <p className="mt-3 text-sm leading-relaxed text-cocoa">{MEDICAL_DIRECTOR.bio}</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
